var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.phoneCodeList.length
    ? _c("selector", {
        attrs: {
          options: _vm.phoneCodeList,
          value: _vm.selectedValue,
          disable: _vm.disable,
          iconType: _vm.iconType
        },
        on: {
          input: function(inp) {
            this$1.$emit("input", inp.replace("+", ""))
          }
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61fa8720", { render: render, staticRenderFns: staticRenderFns })
  }
}